import { render } from "./PaginatedResourceTable.vue?vue&type=template&id=472d2215&ts=true"
import script from "./PaginatedResourceTable.vue?vue&type=script&lang=ts"
export * from "./PaginatedResourceTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__